import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const PinIconButton = ({ color = '#CCC', style = {}, size ='m24', ...attr }) => {
  return (
    <svg {...iconSizes[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        d="M12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11ZM12 11L12 21"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default PinIconButton;
